import {InjectionToken} from '@angular/core';
import {TaskService} from '@twict4fiber/data';

export const TASK_SERVICE = new InjectionToken<TaskService>('DATA_TASK_SERVICE');
